import { useEffect } from "react";

export function usePageSEO({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    return () => {
      document.title = "Ambe Palace | Best Hotel in Dungarpur, Rajasthan";
    };
  }, [title, description]);
}
